import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/joy';
import { QRCodeSVG } from 'qrcode.react';

import CrewModal from './CrewModal';

interface QRModalProps {
  linkToShare: string;
  isOpen: boolean;
  onClose: () => void;
}

const QRModal: React.FC<QRModalProps> = ({ linkToShare, isOpen, onClose }) => {
  const { t } = useTranslation();
  const typographyStyle = {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '150%',
    height: '21px',
    letterSpacing: '0px',
    flex: 'none',
    order: 3,
    flexGrow: 1
  };

  return (
    <CrewModal open={isOpen} onClose={onClose} innerClass='border border-bbYellow' position='bottom-right'>
      <Box className='flex flex-col items-center justify-center mb-3'>
        <Box className='mb-4'>
          <Typography
            level='body-lg'
            sx={{
              ...typographyStyle,
              color: 'text.primary',
              fontWeight: 500,
              minWidth: 'max-content'
            }}
          >
            {t('crew_view.qr_modal.scan_qr_code')}
          </Typography>
        </Box>
        <Box
          className='p-1 rounded-md'
          sx={{ bgcolor: 'common.white', border: 1, borderColor: 'primary.focusVisible' }}
        >
          <QRCodeSVG value={linkToShare} size={244} />
        </Box>
      </Box>
    </CrewModal>
  );
};

export default QRModal;
